import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { handleGetRequest } from "../../../../services/GetTemplate";
import { handlePutRequest } from "../../../../services/PutTemplate";
import { Dropdown } from "primereact/dropdown";
import Loading from "../../../../components/Loader";
import SecuredFileChange from "../../../../components/SecuredFileChange/SecuredFileChange";
import classNames from "classnames";
import { Dialog } from "primereact";
import baseURL, { endPoints } from "../../../../Config";

const EditViewSubPart = ({ onHide, getSubPartList, subPartDataId, isEditable }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(null);
    const [partlogoLink, setPartlogoLink] = useState("");
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [displayImageDialog, setDisplayImageDialog] = useState(false);
    const companyImageRef = useRef(null);

    const categoryTypes = [
        { id: 1, name: "Engine Components" },
        { id: 2, name: "Suspension & Steering" },
        { id: 3, name: "Breaking System" },
        { id: 4, name: "Exhaust System" },
        { id: 5, name: "Body & Exterior" },
        { id: 6, name: "Interior Components" },
        { id: 7, name: "Sensors & Electrical Components" },
        { id: 8, name: "Transmission Components" },
    ];

    const getPartById = async () => {
        setLoading(true);
        const response = await dispatch(handleGetRequest(endPoints.getMasterPartById(subPartDataId), false));

        if (response?.statusCode === 200) {
            const keyData = response?.data;
            const selectedCategory = categoryTypes.find((cat) => cat.id === keyData?.categoryId);
            formik.setFieldValue("id", keyData?.id);
            formik.setFieldValue("name", keyData?.name);
            formik.setFieldValue("categoryId", selectedCategory ? selectedCategory.id : "");
            formik.setFieldValue("imageBase64", keyData?.imageUrl);
            formik.setFieldValue("isActive", keyData?.isActive);
            setPartlogoLink(baseURL + "/" + keyData?.imageUrl);
        }
        setLoading(false);
    };

    useEffect(() => {
        getPartById();
    }, [subPartDataId]);

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            ?.matches(/^[^\s]+(\s[^\s]+)*$/, "Leading and trailing space is not allowed")
            .required("This field is required"),
        categoryId: Yup.number().required("This field is required"),
        imageBase64: Yup.string().required("This field is required"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            id: "",
            name: "",
            categoryId: "",
            imageBase64: "",
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);
            let newdata = {
                id: data?.id,
                name: data?.name,
                categoryId: data?.categoryId,
                imageBase64: selectedFile ? selectedFile : "",
            };

            const response = await dispatch(handlePutRequest(newdata, endPoints.updateMasterPart, false, true));
            if (response?.statusCode === 200) {
                getSubPartList();
                onHide();
            }
            setLoadingBtn(false);
        },
    });

    const previewImage = () => {
        setDisplayImageDialog(true);
    };
    const closeDisplayDialog = () => {
        setDisplayImageDialog(false);
    };

    const handleImageReset = () => {
        formik.setFieldValue("imageBase64", "");
        setSelectedFile(null);
        setPartlogoLink("");
        companyImageRef.current.value = null; // Reset the file input value
    };
    const handleCompanyIcon = () => {
        companyImageRef.current.click();
    };

    function handleCompanyImageChange(event) {
        setSelectedFile(null);
        formik.setFieldValue("imageBase64", "");
        setSelectedFileError("");
        const selectedFile = event.target.files[0];
        const fileTypes = ["image"];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
            setSelectedFileError(error);
        } else if (newFile) {
            setPartlogoLink(URL.createObjectURL(selectedFile));
            formik.setFieldValue("imageBase64", newFile?.name);
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setSelectedFile(base64String);
            };
            reader.readAsDataURL(newFile);
        }
    }

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    console.log("formikkk", formik);

    return (
        <>
            <Dialog visible={displayImageDialog} blockScroll style={{ width: "40vw" }} maskClassName="zindex9999" onHide={() => closeDisplayDialog()} draggable={false}>
                <img src={partlogoLink} style={{ maxWidth: "100%", maxHeight: "100%", width: "900px", height: "500px", objectFit: "contain" }} />
            </Dialog>
            {loading ? <Loading /> : <></>}
            <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid pl-2 pr-2">
                    {" "}
                    <div className="field col-12 md:col-6">
                        <label> Category </label>
                        <span className="Label__Required">*</span>

                        <Dropdown
                            placeholder="Select Category"
                            className={classNames({ "p-invalid": isFormFieldValid("categoryId") }, "Dropdown__Round")}
                            disabled={!isEditable}
                            id="categoryId"
                            name="categoryId"
                            options={categoryTypes}
                            optionValue="id"
                            optionLabel="name"
                            value={formik.values.categoryId}
                            filter
                            showClear={!!formik?.values?.categoryId}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("categoryId", e.target.value ? e.target.value : "");
                            }}
                        />
                        {getFormErrorMessage("categoryId")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Part Name </label>
                        <span className="Label__Required">*</span>
                        <InputText placeholder="Enter Part Name" className={classNames({ "p-invalid": isFormFieldValid("name") }, "Input__Round")} id="name" name="name" type="text" maxLength={50} value={formik.values.name} onChange={formik.handleChange} disabled={!isEditable} />
                        {getFormErrorMessage("name")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> {isEditable ? "Upload logo " : "Part Logo "} </label> <span className="Label__Required">*</span>
                        {isEditable && (
                            <>
                                {" "}
                                <div className="file-input-container " onClick={handleCompanyIcon}>
                                    <input type="file" accept="image/*" style={{ display: "none" }} ref={companyImageRef} onChange={handleCompanyImageChange} disabled={!isEditable} />
                                    <input className={classNames({ "p-invalid": isFormFieldValid("imageBase64") }, "custom-file p-inputtext p-component Input__Round")} type="text" placeholder="Choose a file..." value={formik.values.imageBase64} readOnly />
                                    <span className="file-upload-icon">
                                        <i className="pi pi-paperclip" />
                                    </span>
                                </div>
                            </>
                        )}
                        {selectedFileError ? <small className="p-error">{selectedFileError}</small> : getFormErrorMessage("imageBase64")}
                        {formik?.values?.imageBase64 && (
                            <div style={{ position: "relative", width: "180px", height: "180px", margin: "auto", marginTop: "15px" }}>
                                {isEditable ? <i className="pi pi-times closingIcon" onClick={() => handleImageReset()} style={{ cursor: "pointer", position: "absolute", top: "0", right: "0" }} disabled={!isEditable} /> : ""}
                                <img
                                    src={partlogoLink}
                                    alt="Part Logo"
                                    style={{ maxWidth: "100%", maxHeight: "100%", width: "150px", height: "150px", objectFit: "contain" }}
                                    onClick={() => {
                                        previewImage();
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="col-12 d-flex flex-row text-center mt-4 pb-2">
                        <Button className="Cancel-Button" label="Cancel" type="button" onClick={onHide} />
                        {isEditable === true && <Button className="Save-Button ml-2" label="Update" type="submit" loading={loadingBtn} />}
                    </div>
                </div>
            </form>
        </>
    );
};

export default EditViewSubPart;
